import { Map as map } from 'immutable';
const C = require("../constants");

function WaiterSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.WAITER_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default WaiterSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/WaiterSelectReducer.js